var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 -70.28 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n\t\t\t.cls-1{fill:none;stroke:#17BF87;stroke-linecap:round;stroke-linejoin:round;stroke-width:20px;}\n\t\t"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2",
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "E417, Media, media player, multimedia, player, video player",
    id: "E417_Media_media_player_multimedia_player_video_player"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 351.43,
    width: 492,
    x: 10,
    y: 10
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "191.83 271.28 191.83 100.15 352.26 185.71 191.83 271.28"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 45.4,
    width: 82,
    x: 10,
    y: 10
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 45.4,
    width: 82,
    x: 92,
    y: 10
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 45.4,
    width: 82,
    x: 174,
    y: 10
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 45.4,
    width: 82,
    x: 256,
    y: 10
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 45.4,
    width: 82,
    x: 338,
    y: 10
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 45.4,
    width: 82,
    x: 420,
    y: 10
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 45.4,
    width: 82,
    x: 10,
    y: 316.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 45.4,
    width: 82,
    x: 92,
    y: 316.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 45.4,
    width: 82,
    x: 174,
    y: 316.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 45.4,
    width: 82,
    x: 256,
    y: 316.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 45.4,
    width: 82,
    x: 338,
    y: 316.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 45.4,
    width: 82,
    x: 420,
    y: 316.03
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayer);
export default __webpack_public_path__ + "static/media/player.a0b536807036a00c0d46cc0f460b5aca.svg";
export { ForwardRef as ReactComponent };